import Api from '../../../../shared/Api';
import { Promise } from 'es6-promise';
import { IOrderRow } from './Types';
import { AddedOrderRow } from './EditPage';
import { IEditOrderRowViewModel } from '../basicorderinfo/Types';

class EditOrderApi {
    static view(orderId: number): Promise<any> {
        return new Api().get(`/views/orders/${orderId}/photographer-edit`);
    }

    static editOrderRow(orderId: number, rowId: number): Promise<IEditOrderRowViewModel> {
        return new Api().get(`/views/orders/${orderId}/photographer-edit-rows/${rowId}/edit`);
    }

    static updateOrderRowProduct(orderId: number, rowId: number, productId: number) {
        return new Api().put(`/views/orders/${orderId}/photographer-edit-rows/${rowId}`, {
            productId: productId
        });
    }

    static createOrderRow(orderId: number, data: AddedOrderRow): Promise<any> {
        return new Api().post(`/views/orders/${orderId}/photographer-edit-rows`, data);
    }

    static removeOrderRow(orderId: number, rowId: number): Promise<any> {
        return new Api().delete(`/views/orders/${orderId}/photographer-edit-rows/${rowId}`);
    }
}

export default EditOrderApi;
